export const SESSION_EXPIRED_TITLE = 'Session expired';
export const SESSION_EXPIRED_MESSAGE = 'Your session has expired. Please log in again.';

let sessionExpiredNotified = false;

export function resetAuthSessionExpiredNotification(): void {
  sessionExpiredNotified = false;
}

export function notifyAuthSessionExpired(reason = 'token_refresh_failed'): void {
  if (sessionExpiredNotified || typeof window === 'undefined') return;
  sessionExpiredNotified = true;

  window.dispatchEvent(new CustomEvent('app:toast', {
    detail: {
      type: 'error',
      title: SESSION_EXPIRED_TITLE,
      message: SESSION_EXPIRED_MESSAGE,
      duration: 8000,
    },
  }));

  window.dispatchEvent(new CustomEvent('auth:logout', {
    detail: { reason },
  }));
}
